import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { VehicleJourneyPage } from 'pages/VehicleJourney';
import { PortariaAccessPage } from 'pages/PortariaAccess';
import type React from 'react';

const vehicleJourneyRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => {
  const adminElement = (element: React.ReactElement) =>
    userBelongsToAnyOf('admin') ? (
      element
    ) : (
      <Navigate to="/" state={{ from: location }} />
    );

  return {
    path: 'jornada-veiculo',
    element: <Outlet />,
    children: [
      {
        path: 'parametrizacoes',
        element: adminElement(<VehicleJourneyPage />),
      },
      {
        path: 'controle-de-acesso',
        element: adminElement(<PortariaAccessPage />),
      },
    ],
  };
};

export default vehicleJourneyRoutes;
